import React, { Component } from 'react';
import {Toast} from "antd-mobile";
import questionTye from '../common/questionTye';

class Topic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rateJg:[],
      maxrate:18,
      data:[]
  }
}
 rate=(id,pro,index,questionType,e)=>{
  let rateJg1=this.state.rateJg;
  let rateVal=(e.target.value)/1
//  let rateVal=e.target.value.replace(/[^\d]/g,"");
 if(rateVal>(pro/1)){
  rateJg1[index]=true;
  this.setState({
    rateJg:rateJg1
  })

 }else{
  rateJg1[index]=false;
  this.setState({
    rateJg:rateJg1
  })

 }
  
}

ratea=(id,pro,index,questionType,e)=>{
  if((e.target.value)/1>=0){  
    let rateJg1=this.state.rateJg;  
    // let rateVal=e.target.value.replace(/[^\d]/g,"");
    let rateVal=(e.target.value)/1;
    if(rateVal>(pro/1)){
      rateJg1[index]=true;
      this.setState({
        rateJg:rateJg1
      })

    }else{
      rateJg1[index]=false;
      this.setState({
        rateJg:rateJg1
      })
      this.props.subCard(id,this.checkoutDotted(e.target.value),1,this.checkoutDotted(e.target.value),questionType);

    }
  }else{
    Toast.info('自评得分不能为负!', 1);
  }   
}
componentDidMount(){
  this.setState({
    data: this.props.data,
    
  })  
}
componentWillReceiveProps = (nextProps) => {
  this.setState({
    data: nextProps.data
  }) 
  let rateJg=[];
  if(this.state.data){
    for(let i=0;i<this.state.data.length;i++)
    {
      rateJg.push(false);
    }
    this.setState({
      rateJg:rateJg
    })
  }
  
}
checkoutDotted = (value) =>{
  let rep=/[\.]/;
  rep.test(value)
  if(!rep.test(value)){
    return value
  }else{
    return (Math.round(value*100))/100
  }
}
imgShow=(e)=>{

  this.props.imgShow(e);
}
componentDidUpdate(){
  
}
// value=value
  render() {
    if(this.state.data&&this.state.data.length>0){
    return (
      <div>
         <div className="qus_title">
         {/* {this.props.listXX}:{this.props.title}（本大题共 {this.state.data.length} 小题） */}
          </div>
          {
          this.state.data.map((val,index)=>{
                return(
                  <div key={index}>
                  <div className="single_title" onClick={this.imgShow}>
                  {this.props.Skey}.({`${questionTye.handleType(val.questionType)}`}) <span dangerouslySetInnerHTML = {{ __html:val.question }}></span>({val.questionGrade}分)
                  </div>
                 <p className="rate_con">
                   <input type="number" inputMode="decimal" step="0.01" className={this.state.rateJg[index]===true?"user_rate rate_err":"user_rate"}  disabled={val.cardList&&val.cardList.length>0}   placeholder={val.cardList&&val.cardList.length>0&&val.cardList[0].optChoose!==null?val.cardList[0].optChoose:`请输入您的自评得分，该题满分为${val.questionGrade}分`} ref="user_rate" pattern="[0-9]*" onBlur={this.ratea.bind(this,val.id,val.questionGrade,index,val.questionType)} onChange={this.rate.bind(this,val.id,val.questionGrade,index,val.questionType)} />
                   <span className={this.state.rateJg[index]===true?"jg_txt1":"jg_txt1 none"}>您的分数超过了该题的满分，请重新评估分数</span>
                 </p>
                 {
                  <div className="ans_con" onClick={this.imgShow}>
                  {
                      val.cardList&&val.cardList.length>0?  
                      <div className="ans_title">您的分数是 <span className="ans_right ans_blk ans_self">{val.answerList.cardList<0?"0":val.cardList[0].score}分</span></div>
                      :<div></div>
                    }
                      <div className="ans_title">正确答案是 <span className="ans_right ans_blk">{val.answerList.length<0?"见解析":<span dangerouslySetInnerHTML = {{ __html:val.answerList[0].answer}}></span>}</span></div>
                   <div className='ans_tip'>解析</div>
                   <div className="ans_jx"><span dangerouslySetInnerHTML = {{ __html:val.analysis}}></span></div>
                  </div>
                 }
                  
                </div>
                 )
          })
        }
      
      </div>
    );
 
}else{
  return(<div></div>)
}
}
}

export default Topic;
